import { AdjacentType, BranchingQueryDefinition, getChildEdgeTypeId } from '@iotv/datamodel';
import { ComparisonType, LogicalOperatorType } from '../../../types';
/**
 * Should be deprecated?
 * @depreacted
 */
export const getCustomerEntitys = (entityType) => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Customer' }],
        subQueries: [],
    });
    const customerToGroupQuery = new BranchingQueryDefinition({
        id: 'customerToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId('Customer', 'Group'),
                // nodeFilters: [
                //   {
                //     filters: [
                //       {
                //         key: 'supportedType',
                //         predicate: ComparisonType.EQUALS,
                //         value: entityType,
                //       },
                //     ],
                //     setOperation: LogicalOperatorType.AND,
                //   },
                // ],
            },
        ],
        subQueries: [],
    });
    const groupToGroupQuery = new BranchingQueryDefinition({
        id: 'groupToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: getChildEdgeTypeId('Group', 'Group'),
                nodeFilters: [
                    {
                        filters: [
                            {
                                key: 'supportedType',
                                predicate: ComparisonType.EQUALS,
                                value: entityType,
                            },
                        ],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToEntityQuery = new BranchingQueryDefinition({
        id: 'groupToEntityQuery',
        path: [
            {
                objectTypeId: entityType,
                adjacencyType: AdjacentType.CHILD,
                // edgeTypeId: getChildEdgeTypeId('Group', entityType),
            },
        ],
        subQueries: [],
    });
    const entityToDeviceQuery = new BranchingQueryDefinition({
        id: 'entityToDeviceQuery',
        path: [
            {
                objectTypeId: 'Device',
                adjacencyType: AdjacentType.CHILD,
                // edgeTypeId: getChildEdgeTypeId(entityType, 'Device),
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(customerToGroupQuery);
    customerToGroupQuery.addSubQuery(groupToGroupQuery);
    groupToGroupQuery.addSubQuery(groupToEntityQuery);
    customerToGroupQuery.addSubQuery(groupToEntityQuery);
    groupToEntityQuery.addSubQuery(entityToDeviceQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
/**
 * Should be deprecated?
 * @depreacted
 */
export const getPropertyEntitys = (entityType) => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Property' }],
        subQueries: [],
    });
    const propertyToGroupQuery = new BranchingQueryDefinition({
        id: 'propertyToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: undefined, //getChildEdgeTypeId('Property', entityType),
            },
        ],
        subQueries: [],
    });
    const groupToEntityQuery = new BranchingQueryDefinition({
        id: 'groupToEntityQuery',
        path: [
            {
                objectTypeId: entityType,
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: undefined, //getChildEdgeTypeId('Property', entityType),
            },
        ],
        subQueries: [],
    });
    const propertyToEntityQuery = new BranchingQueryDefinition({
        id: 'propertyToEntityQuery',
        path: [
            {
                objectTypeId: entityType,
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: undefined, //getChildEdgeTypeId('Property', entityType),
            },
        ],
        subQueries: [],
    });
    const entityToDeviceQuery = new BranchingQueryDefinition({
        id: 'entityToDeviceQuery',
        path: [
            {
                objectTypeId: 'Device',
                adjacencyType: AdjacentType.CHILD,
                // edgeTypeId: getChildEdgeTypeId(entityType, 'Device),
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(propertyToEntityQuery);
    propertyToEntityQuery.addSubQuery(entityToDeviceQuery);
    apexQuery.addSubQuery(propertyToGroupQuery);
    propertyToGroupQuery.addSubQuery(groupToEntityQuery);
    groupToEntityQuery.addSubQuery(entityToDeviceQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
export const getCustomerDevGroupsAndAreas = () => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Customer' }],
        subQueries: [],
    });
    const customerToGroupQuery = new BranchingQueryDefinition({
        id: 'customerToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId('Customer', 'Group'),
                nodeFilters: [
                    {
                        filters: [
                            {
                                key: 'supportedType',
                                predicate: ComparisonType.EQUALS,
                                value: 'Device',
                            },
                        ],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToGroupQuery = new BranchingQueryDefinition({
        id: 'groupToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: getChildEdgeTypeId('Group', 'Group'),
                nodeFilters: [
                    {
                        filters: [
                            {
                                key: 'supportedType',
                                predicate: ComparisonType.EQUALS,
                                value: 'Device',
                            },
                        ],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const customerToPropertyQuery = new BranchingQueryDefinition({
        id: 'customerToPropertyQuery',
        path: [
            {
                objectTypeId: 'Property',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId('Customer', 'Property'),
            },
        ],
        subQueries: [],
    });
    const propertyToAreaQuery = new BranchingQueryDefinition({
        id: 'propertyToAreaQuery',
        path: [
            {
                objectTypeId: 'Area',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId('Property', 'Area'),
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(customerToGroupQuery);
    customerToGroupQuery.addSubQuery(groupToGroupQuery);
    apexQuery.addSubQuery(customerToPropertyQuery);
    customerToPropertyQuery.addSubQuery(propertyToAreaQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
